/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_Q4Inputs */

const en_guide_json_rest_api_faq_q4 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What status code should go with a JSON error body?`)
};

const ko_guide_json_rest_api_faq_q4 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 오류 본문에는 어떤 상태 코드를 함께 써야 하나요?`)
};

const ja_guide_json_rest_api_faq_q4 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON のエラー本文にはどのステータスコードを添えるべきですか?`)
};

/**
* | output |
* | --- |
* | "What status code should go with a JSON error body?" |
*
* @param {Guide_Json_Rest_Api_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_q4 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_q4(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_q4(inputs)
	return ja_guide_json_rest_api_faq_q4(inputs)
});